import React from 'react';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { timelineEntrypoint as legacyTimelineEntrypoint } from '@jira/spa-apps__business-timeline/src/timelineEntrypoint.entrypoint.tsx';
import { timelineEntrypoint } from '@jira/spa-apps__business-harmonised-timeline/src/timelineEntrypoint.entrypoint.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { businessProjectLayout } from '@jira/platform__layouts-business-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraBusinessTimelineRoute } from '@jira/router-routes__business-timeline-routes/src/jiraBusinessTimelineRoute.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import type { Route } from '@atlassian/react-resource-router';

const timelinePageEntrypoint = createPageEntryPoint({
	main: timelineEntrypoint,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

const legacyTimelinePageEntrypoint = createPageEntryPoint({
	main: legacyTimelineEntrypoint,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

export const jiraBusinessTimelineRouteEntry: Route = createEntry(jiraBusinessTimelineRoute, () => ({
	group: 'classic-business',
	ufoName: 'jwm.timeline-view',
	layout: businessProjectLayout,
	skeleton: fg('timeline_skeleton_update') ? BusinessTimelineSkeleton : ThemedLazySkeleton,
	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncHorizontalNavJira,
	},
	resources: getProjectViewResources(),
	entryPoint: () =>
		// eslint-disable-next-line jira/ff/no-preconditioning
		fg('jira_timeline_harmonisation_m1_targeting') &&
		expValEquals('jira_timeline_harmonisation_m1', 'isEnabled', true)
			? timelinePageEntrypoint
			: legacyTimelinePageEntrypoint,
	supportsPreviewPanel: true,
	supportsProjectTheme: 'full',
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));

const BusinessTimelineSkeleton = () => (
	<Box xcss={timelineSkeletonContainerStyles}>
		<ThemedLazySkeleton />
	</Box>
);

const timelineSkeletonContainerStyles = xcss({
	height: '100%',
	backgroundColor: 'elevation.surface',
	borderRadius: 'radius.large',
	overflow: 'hidden',
});
